function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import pick from 'ramda/src/pick';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { AngularFormControllerErrorAdapter } from 'invision-core';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { getMemberBySubscriberId, sortMemberListByAlpheticalOrder } from '../../household/household.helpers';
import { retrieveConvergentBillerSubscriberSummary } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { retrieveCustomerHouseholds, setSelectedHouseholdMember, updateHouseholdServicesAssociations } from '../../../../reducers/actions/customer.household.actions';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { ConvergentBillerSubscriberSummaryServicesSelector, IsFetchingSubscriberSummarySelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { CanMakeHouseholdChangesSelector, CurrentHouseholdSelector, HeadOfHouseholdSelector, HouseholdErrorSelector, HousholdMembersSortedForServiceAssociation, HouseholdServicesAssociations, IsFetchingHouseholdSelector, IsUpdatingHouseholdServicesAssociationsSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { HOUSEHOLD_STATE_NAME } from '../household.constants';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { NA } from '../../../../reducers/constants/billing.payments.constants';
var AssociateServicesController = /*#__PURE__*/function () {
  function AssociateServicesController($ngRedux, uiNotificationService) {
    _classCallCheck(this, AssociateServicesController);
    this.$ngRedux = $ngRedux;
    this.uiNotificationService = uiNotificationService;
    this.associateServicesFormErrors = [];
    this.ASSOCIATE_SERVICES_FIELDNAME_PREFIX = 'service_association';
    this.ASSOCIATE_SERVICES_TRANSLATED_FIELD_LABEL = i18n.translate(CustomerCareLocaleKeys.HOUSEHOLD.SERVICE);
    this.currentHouseholdMembers = [];
    this.currentHouseholdServicesAssociations = [];
    this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    this.HOUSEHOLD_STATE_NAME = HOUSEHOLD_STATE_NAME;
    this.stateOrName = 'index.customercare.customer.associateservices';
    this.uiNotificationService = uiNotificationService;
    this.NA = NA;
    this.handleHouseholdAction = this.handleHouseholdAction.bind(this);
  }
  return _createClass(AssociateServicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          canMakeChanges: CanMakeHouseholdChangesSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentHousehold: CurrentHouseholdSelector(store),
          currentHouseholdMembers: HousholdMembersSortedForServiceAssociation(store),
          currentHouseholdServicesAssociations: HouseholdServicesAssociations(store),
          headOfHousehold: HeadOfHouseholdSelector(store),
          householdError: HouseholdErrorSelector(store),
          isFetchingHouseholds: IsFetchingHouseholdSelector(store),
          isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
          isUpdatingHouseholdServicesAssociations: IsUpdatingHouseholdServicesAssociationsSelector(store),
          regularExpressionLoaded: MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          serviceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          subscriberServices: ConvergentBillerSubscriberSummaryServicesSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: fetchCodeTypesThunk,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        setSelectedHouseholdMember: setSelectedHouseholdMember,
        stateGo: stateGo,
        updateHouseholdServicesAssociations: updateHouseholdServicesAssociations
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.createMemberPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.createMemberPopupApi = event.api;
        }
      };
      this.notifyUserWithMessage = function (message) {
        _this.uiNotificationService.success(message, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      };
      if (this.state.subscriberServices) {
        this.retrieveCustomerHousehold();
      } else {
        this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId).then(function () {
          _this.retrieveCustomerHousehold();
        });
      }
      this.saveHouseholdMemberServiceAssociationsSuccessCallback = function () {
        _this.associateServicesForm.$setPristine();
        _this.actions.stateGo(HOUSEHOLD_STATE_NAME);
        _this.uiNotificationService.success(i18n.translate(_this.CustomerCareLocaleKeys.HOUSEHOLD.UPDATE_HOUSEHOLD_SERVICES_ASSOCIATIONS_SUCCESS), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      };
      this.saveHouseholdMemberServiceAssociationsErrorCallback = function () {
        _this.uiNotificationService.error(_this.state.householdError.message, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      };
      if (!this.state.serviceAttributesLoaded) {
        this.actions.fetchCodeType(CODES.ServiceAttribute);
      }
      if (!this.state.regularExpressionLoaded) {
        this.actions.fetchCodeType(CODES.RegularExpression);
      }
    }
  }, {
    key: "householdNeedsToBeFetched",
    value: function householdNeedsToBeFetched() {
      return !this.state.isFetchingHouseholds && (!this.state.currentHousehold || !this.state.currentHouseholdMembers || !this.state.headOfHousehold);
    }
  }, {
    key: "showMemberPopup",
    value: function showMemberPopup() {
      this.createMemberPopupApi.open();
    }
  }, {
    key: "retrieveCustomerHousehold",
    value: function retrieveCustomerHousehold() {
      var _this2 = this;
      if (this.householdNeedsToBeFetched()) {
        this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, false).then(function () {
          _this2.retrieveCurrentHouseholdMembers();
          _this2.retrieveCurrentHouseholdServicesAssociations();
          _this2.redirectNoServiceAssociations();
        });
      } else {
        this.retrieveCurrentHouseholdMembers();
        this.retrieveCurrentHouseholdServicesAssociations();
      }
    }
  }, {
    key: "redirectNoServiceAssociations",
    value: function redirectNoServiceAssociations() {
      if (this.state.currentHouseholdServicesAssociations.length === 0) {
        this.actions.stateGo(this.HOUSEHOLD_STATE_NAME);
      }
    }
  }, {
    key: "retrieveCurrentHouseholdMembers",
    value: function retrieveCurrentHouseholdMembers() {
      this.currentHouseholdMembers = clone(this.state.currentHouseholdMembers);
      this.currentHouseholdMembers = sortMemberListByAlpheticalOrder(this.currentHouseholdMembers, this.state.headOfHousehold, true);
    }
  }, {
    key: "retrieveCurrentHouseholdServicesAssociations",
    value: function retrieveCurrentHouseholdServicesAssociations() {
      var _this3 = this;
      this.currentHouseholdServicesAssociations = clone(this.state.currentHouseholdServicesAssociations).map(function (currentHouseholdServicesAssociation) {
        return Object.assign(currentHouseholdServicesAssociation, {
          serviceFieldName: "".concat(_this3.ASSOCIATE_SERVICES_FIELDNAME_PREFIX, "-").concat(currentHouseholdServicesAssociation.ServiceIdentifier)
        });
      });
    }
  }, {
    key: "clearForm",
    value: function clearForm() {
      this.associateServicesForm.$setPristine();
      this.actions.stateGo(this.HOUSEHOLD_STATE_NAME);
    }
  }, {
    key: "updateHouseholdMemberServiceAssociations",
    value: function updateHouseholdMemberServiceAssociations(service) {
      var _this4 = this;
      if (!service.SubscriberId) {
        service.SubscriberId = this.state.headOfHousehold.SubscriberId;
      }
      this.currentHouseholdMembers = this.currentHouseholdMembers.map(function (householdMember) {
        var associatedServices = _this4.currentHouseholdServicesAssociations.filter(function (serviceAssociation) {
          return serviceAssociation.SubscriberId === householdMember.SubscriberId;
        }).map(function (serviceAssociation) {
          return pick(['ServiceFriendlyName', 'ServiceIdentifier'], serviceAssociation);
        });
        return Object.assign(householdMember, {
          services: associatedServices
        });
      });
    }
  }, {
    key: "handleHouseholdAction",
    value: function handleHouseholdAction(message, memberId) {
      var _this5 = this;
      this.uiNotificationService.success(message, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.retrieveHouseholds().then(function () {
        _this5.setSelectedMember(getMemberBySubscriberId(_this5.state.currentHousehold.Members, memberId));
      });
    }
  }, {
    key: "retrieveHouseholds",
    value: function retrieveHouseholds() {
      var INCLUDE_REMOVED = true;
      return this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, INCLUDE_REMOVED);
    }
  }, {
    key: "setSelectedMember",
    value: function setSelectedMember(member) {
      this.actions.setSelectedHouseholdMember(!member || member.isOverview ? null : member.SubscriberId);
    }
  }, {
    key: "buildDynamicFormFieldNames",
    value: function buildDynamicFormFieldNames() {
      var _this6 = this;
      var dynamicFormFieldNames = {};
      this.currentHouseholdServicesAssociations.forEach(function (currentHouseholdServicesAssociation) {
        dynamicFormFieldNames[currentHouseholdServicesAssociation.serviceFieldName] = "".concat(_this6.ASSOCIATE_SERVICES_TRANSLATED_FIELD_LABEL, " \"").concat(currentHouseholdServicesAssociation.ServiceIdentifier, "\"");
      });
      return dynamicFormFieldNames;
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isFetchingSubscriberSummary || this.state.isUpdatingHouseholdServicesAssociations;
    }
  }, {
    key: "saveHouseholdMemberServiceAssociations",
    value: function saveHouseholdMemberServiceAssociations() {
      if (this.associateServicesForm.$valid) {
        var formattedServicesAssociations = this.currentHouseholdServicesAssociations.map(function (currentHouseholdServicesAssociation) {
          return {
            ServiceIdentifier: {
              Value: currentHouseholdServicesAssociation.ServiceIdentifier,
              FriendlyName: currentHouseholdServicesAssociation.ServiceFriendlyName
            },
            SubscriberId: currentHouseholdServicesAssociation.SubscriberId
          };
        });
        var data = {
          headOfHouseholdSubscriberId: this.state.currentHousehold.HeadOfHouseholdSubscriberId,
          householdServicesAssociations: formattedServicesAssociations,
          subscriberId: this.state.currentCustomerId
        };
        this.actions.updateHouseholdServicesAssociations(data).then(this.saveHouseholdMemberServiceAssociationsSuccessCallback).catch(this.saveHouseholdMemberServiceAssociationsErrorCallback);
      } else {
        this.associateServicesFormErrors = AngularFormControllerErrorAdapter(this.associateServicesForm, this.buildDynamicFormFieldNames());
      }
    }
  }, {
    key: "showFormErrors",
    value: function showFormErrors(fieldName) {
      return this.associateServicesForm[fieldName].$invalid;
    }
  }]);
}();
export default {
  template: require('./associate.services.template.html'),
  bindings: {},
  controllerAs: 'AssociateServicesController',
  controller: AssociateServicesController
};